import {
    createContext,
    useContext,
    useMemo,
    useState,
    type Dispatch,
    type ReactNode,
    type SetStateAction
} from 'react';

type ConsumerNameContextValue = [string, Dispatch<SetStateAction<string>>];

const ConsumerNameContext = createContext<ConsumerNameContextValue | null>(null);

function useAggregatorConsumerName(): ConsumerNameContextValue {
    const context = useContext(ConsumerNameContext);
    if (!context) {
        throw new Error(`useConsumerName must be used within a ConsumerNameProvider`);
    }
    return context;
}

function AggregatorConsumerNameProvider(props: { children: ReactNode }): ReactNode {
    const [aggregatorConsumerName, setAggregatorConsumerName] = useState('');
    const value = useMemo<ConsumerNameContextValue>(
        () => [aggregatorConsumerName, setAggregatorConsumerName],
        [aggregatorConsumerName]
    );
    return <ConsumerNameContext.Provider value={value} {...props} />;
}

export { AggregatorConsumerNameProvider, useAggregatorConsumerName };
